// Shared motion-presets for chat-area components — extracted out of components
// so React doesn't recreate these object literals on every render.

export const fadeOverlay = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.15 },
};

export const slideUpSheet = {
    initial: { y: 24, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    exit: { y: 24, opacity: 0 },
    transition: { duration: 0.22, ease: [0.22, 1, 0.36, 1] },
};
